export const DEFAULT_BRANDING_COLORS: IBrandingColors = {
  primary: "#1782FF",
  secondary: "#337CC1",
  accent: "#8A3FFC",
  background: "#F6F8FC",
  text: "#18191B",
  error: "#EC5444",
  success: "#40DC91",
  warning: "#F6C23A",
};

export const DEFAULT_BRANDING_TYPOGRAPHY: IBrandingTypography = {
  fontFamily: "'Inter', sans-serif",
  headingFontFamily: "'Inter', sans-serif",
};

export const DEFAULT_BRANDING_METADATA: IBrandingMetadata = {
  companyName: "Kt estate AI Agent",
};

export const DEFAULT_BRANDING_EMAIL: IBrandingEmailBranding = {
  fromName: "Kt estate AI Agent",
  fromEmail: "noreply@ktestate.com",
};

export const DEFAULT_BRANDING_LOGIN_PAGE: IBrandingLoginPage = {
  showPoweredBy: true,
};

export const DEFAULT_BRANDING_LOGO: IBrandingLogoConfig = {
  light: "",
  dark: "",
  favicon: "",
};

export const DEFAULT_BRANDING_CONFIG: IBrandingConfig = {
  organizationId: "",
  logo: DEFAULT_BRANDING_LOGO,
  colors: DEFAULT_BRANDING_COLORS,
  typography: DEFAULT_BRANDING_TYPOGRAPHY,
  emailBranding: DEFAULT_BRANDING_EMAIL,
  loginPage: DEFAULT_BRANDING_LOGIN_PAGE,
  metadata: DEFAULT_BRANDING_METADATA,
};

export const BRANDING_CSS_VAR_PREFIX = "--brand";

export const DEFAULT_APP_TITLE = "AI Agent";
export const DEFAULT_FAVICON_PATH = "/kt-small-logo.png";
